import _find from 'lodash/find'
import _result from 'lodash/result'
import _map from 'lodash/map'
import _get from 'lodash/get'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DisableSectionByPermissionWrapper } from '../hoc'

import { RouteLeavingGuard } from '../_library/RouteLeavingGuard'
import Card from '../_library/Card'
import GuestTicketDelegations from './guesttickets/Delegations'

// actions
import { FETCH_EVENT_TICKETS, FETCH_EVENT_TABLES } from '../../_common/redux/tickets/actions'
import { UPLOAD_GUESTTICKETS, GET_SEAT_MAP_DATA } from '../../_common/redux/guesttickets/actions'
import { FETCH_EVENT_ADDONS } from '../../_common/redux/addons/actions'
import {
  FETCH_INVENTORY_DELEGATIONS,
  CREATE_INVENTORY_DELEGATION,
  DELETE_INVENTORY_DELEGATION,
  UPDATE_INVENTORY_DELEGATION,
  UPDATE_INVENTORY_DELEGATION_TYPE,
} from '../../_common/redux/inventorydelegations/actions'

import {
  get_event,
  get_event_tickets,
  get_event_tables,
  get_event_addons,
  get_event_inventorydelegations,
  get_email_templates,
} from '../../_common/core/selectors'
import { showAxiosError, showMessage, showSuccessMessage } from '../utils/messenger'
import { getTitle } from '../utils/getTitle'
import { FETCH_EMAIL_TEMPLATES } from '../../_common/redux/emailtemplates/actions'
import { CANCEL_INVITATION } from '../../_common/redux/invitation/actions'

@withRouter
@connect(
  state => {
    const event = get_event(state)
    const tickets = get_event_tickets(state)
    const tables = get_event_tables(state)
    const addons = get_event_addons(state)
    const inventoryDelegations = get_event_inventorydelegations(state)
    const emailTemplates = get_email_templates(state)

    let seatData = null
    const stateEventId = state.guesttickets.eid
    const eid = event.id
    const { seatDataChecked, ticketTypes } = state.guesttickets
    const { statuses } = state.guesttickets
    const reservation_eid = state.guesttickets.eid

    if (stateEventId === eid) {
      // eslint-disable-next-line prefer-destructuring
      seatData = state.guesttickets.seatData
    }

    return {
      user: state.auth.user,
      event,
      reservation_eid,
      tickets,
      tables,
      addons,
      inventoryDelegations,
      inventoryDelegationsLoading: state.loading.has('FETCH_INVENTORY_DELEGATIONS'),
      seatData,
      seatDataChecked,
      getSeatDataLoading: state.loading.has('GET_SEAT_MAP_DATA'),
      statuses,
      getSeatDataStatusesLoading: state.loading.has('GET_SEAT_MAP_STATUSES'),
      ticketTypes,
      emailTemplates,
    }
  },
  {
    FETCH_EVENT_TICKETS,
    FETCH_EVENT_TABLES,
    GET_SEAT_MAP_DATA,
    UPLOAD_GUESTTICKETS,
    FETCH_EVENT_ADDONS,
    FETCH_INVENTORY_DELEGATIONS,
    CREATE_INVENTORY_DELEGATION,
    DELETE_INVENTORY_DELEGATION,
    UPDATE_INVENTORY_DELEGATION,
    UPDATE_INVENTORY_DELEGATION_TYPE,
    CANCEL_INVITATION,
    FETCH_EMAIL_TEMPLATES,
  },
)
export default class EventDelegations extends React.Component {
  constructor(props) {
    super(props)
    form_helper_reset()
    this.mounted = false
    this.createNewDelegation = this.createNewDelegation.bind(this)
    this.deleteDelegation = this.deleteDelegation.bind(this)
    this.updateDelegation = this.updateDelegation.bind(this)
    this.updateDelegationType = this.updateDelegationType.bind(this)

    this.channel = new BroadcastChannel('emailTemplates')
  }
  componentDidMount() {
    Messenger.options = {
      extraClasses: 'messenger-fixed messenger-on-top messenger-on-right',
      theme: 'future',
    }

    const {
      event: { id, flagSeatMapAllowed, displayName },
      reservation_eid,
      FETCH_EVENT_TICKETS,
      FETCH_EVENT_TABLES,
      FETCH_EVENT_ADDONS,
      FETCH_INVENTORY_DELEGATIONS,
      GET_SEAT_MAP_DATA,
      configs,
      FETCH_EMAIL_TEMPLATES,
    } = this.props

    const configDocTitle = _get(configs, 'messages.documentTitle', '')
    document.title = getTitle(configDocTitle, [displayName])

    Promise.resolve(FETCH_EVENT_TICKETS(id)).catch()
    Promise.resolve(FETCH_EVENT_ADDONS(id)).catch()
    Promise.resolve(FETCH_EVENT_TABLES(id)).catch()
    Promise.resolve(FETCH_EMAIL_TEMPLATES(id)).catch()

    this.mounted = true

    FETCH_INVENTORY_DELEGATIONS(id)
    if (flagSeatMapAllowed) {
      if (+id !== +reservation_eid) {
        GET_SEAT_MAP_DATA(id).catch(() => {})
      }
    }

    this.channel.addEventListener('message', this.handleEmailTemplateCreated)
  }

  componentWillUnmount() {
    form_helper_reset()
    this.mounted = false

    if (this.channel) {
      this.channel.removeEventListener('message', this.handleEmailTemplateCreated)
      this.channel.close()
    }
  }

  handleEmailTemplateCreated = event => {
    const {
      event: { id },
      FETCH_EMAIL_TEMPLATES,
    } = this.props

    if (event.data.eventId === id) {
      FETCH_EMAIL_TEMPLATES(id)
    }
  }

  routerWillLeave = () => !form_helper_isEditted()

  createNewDelegation(data) {
    const { event, CREATE_INVENTORY_DELEGATION } = this.props
    return CREATE_INVENTORY_DELEGATION(event.id, data)
  }

  deleteDelegation(did) {
    const { event, DELETE_INVENTORY_DELEGATION } = this.props
    return DELETE_INVENTORY_DELEGATION(did, event.id)
  }

  updateDelegation(did, data) {
    const { event, UPDATE_INVENTORY_DELEGATION } = this.props
    return UPDATE_INVENTORY_DELEGATION(did, event.id, data)
  }
  updateDelegationType(did, data) {
    const { event, UPDATE_INVENTORY_DELEGATION_TYPE, FETCH_INVENTORY_DELEGATIONS } = this.props
    return Promise.resolve(UPDATE_INVENTORY_DELEGATION_TYPE(did, event.id, data))
      .catch(err => Promise.reject(_result(err, 'toFieldErrors', err)))
      .then(async v => {
        FETCH_INVENTORY_DELEGATIONS(event.id)
        return v
      })
  }

  cancelInvitation = async invitation => {
    const { CANCEL_INVITATION } = this.props
    try {
      const res = await CANCEL_INVITATION(invitation.id)
      showMessage('success', _get(res, 'data.message') || 'Successfully cancel!', 5, true)
    } catch (err) {
      showAxiosError(err, _get(err, 'err[0].details'))
      throw err
    }
  }

  render() {
    const {
      event,
      tickets,
      tables,
      inventoryDelegations,
      inventoryDelegationsLoading,
      configs,
      emailTemplates,
    } = this.props
    const showGuestTicketDelegation = _get(configs, 'appearance.showGuestTicketDelegation', true)

    return (
      <DisableSectionByPermissionWrapper>
        <div className="EventGuestTickets">
          <RouteLeavingGuard routerWillLeave={this.routerWillLeave} />

          {showGuestTicketDelegation ? (
            <Card title="Delegations">
              <p>
                Delegations allow you to grant permission to third parties (such as sponsors, exhibitors and
                agents) to issue/manage their own limited number of tickets.
              </p>
              <GuestTicketDelegations
                event={event}
                tickets={tickets}
                tables={tables}
                delegations={inventoryDelegations}
                loading={inventoryDelegationsLoading}
                onCreateNew={this.createNewDelegation}
                onDelete={this.deleteDelegation}
                onUpdate={this.updateDelegation}
                onUpdateType={this.updateDelegationType}
                onCancelInvitation={this.cancelInvitation}
                emailTemplates={emailTemplates}
              />
            </Card>
          ) : null}
        </div>
      </DisableSectionByPermissionWrapper>
    )
  }
}
